// ISO8601の精度を持つDate
export type ISO8601Date = Date

// YYYY-MM-DDの精度を持つDate
export type YYYYMMDDDate = Date

export function isActive<T extends { isActive: boolean }>(value: T): boolean {
  return value.isActive
}
